(() => {
  if (window.__gzLiveMotionV2) return;
  window.__gzLiveMotionV2 = true;

  const docEl = document.documentElement;
  docEl.classList.add('gz-motion-js');

  const revealSelectors = [
    '.gz-spotlight__header',
    '.gz-spotlight__hero',
    '.gz-spotlight__rail > li',
    '.gz-manga__header',
    '.gz-manga__item',
    '.gz-story',
    '.gz-video-studio__head',
    '.gz-video-studio__card',
    '.featured-collection .grid__item',
    'collection-component .grid__item'
  ];

  const prepareReveals = () => {
    const targets = [];
    revealSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el, index) => {
        if (el.dataset.gzMotionReady === '1') return;
        el.dataset.gzMotionReady = '1';
        el.classList.add('gz-enter');
        el.dataset.gzDelay = String((index % 4) + 1);
        targets.push(el);
      });
    });

    if (!targets.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach((el) => el.classList.add('gz-enter--visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gz-enter--visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

    targets.forEach((el) => observer.observe(el));
  };

  const initPointerMotion = () => {
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;

    document.querySelectorAll('.product-card-wrapper').forEach((card) => {
      if (card.dataset.gzTiltReady === '1') return;
      card.dataset.gzTiltReady = '1';

      let frame = null;
      let lastEvent = null;

      const render = () => {
        frame = null;
        if (!lastEvent) return;
        const rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        const px = Math.max(0, Math.min(1, (lastEvent.clientX - rect.left) / rect.width));
        const py = Math.max(0, Math.min(1, (lastEvent.clientY - rect.top) / rect.height));
        const rx = (0.5 - py) * 3.2;
        const ry = (px - 0.5) * 3.2;

        card.style.transform = 'translateY(-6px)';
      };

      card.addEventListener('pointermove', (event) => {
        lastEvent = event;
        if (!frame) frame = requestAnimationFrame(render);
      }, { passive:true });

      card.addEventListener('pointerleave', () => {
        lastEvent = null;
        if (frame) cancelAnimationFrame(frame);
        frame = null;
        card.style.transform = '';
      }, { passive:true });
    });
  };

  const boot = () => {
    prepareReveals();
    initPointerMotion();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once:true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();